import { useEventListeners } from '../utils';

export default class BaseComponent {
	constructor() {
		({ addListener: this.addListener, removeAllListeners: this.removeAllListeners } = useEventListeners(this));
	}

	destroy() {
		this.removeAllListeners();
	}
}
